/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyRipple = createReactComponent("outline", "currency-ripple", "IconCurrencyRipple", [["path", { "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M10 12h3l2 -2.5", "key": "svg-3" }], ["path", { "d": "M15 14.5l-2 -2.5", "key": "svg-4" }]]);

export { IconCurrencyRipple as default };
//# sourceMappingURL=IconCurrencyRipple.mjs.map
